module.exports = __webpack_public_path__ + "static/img/cc_01.3362b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/jiameng/cc_01.png
// module id = YddX
// module chunks = 0